/* BKFK Parallax JS - Viewport Relative Implementation */

(function() {
    function animateParallax() {
        const items = document.querySelectorAll(".parallax-item");
        const vh = window.innerHeight;
        const viewportCenter = vh / 2;
        
        if (items.length > 0) {
            items.forEach(function(item) {
                const rect = item.getBoundingClientRect();
                
                // Only animate if the item's parent section is somewhat in view for performance
                // But for simplicity and smoothness, we can just check rect.top
                if (rect.top < vh && rect.bottom > 0) {
                    const speed = parseFloat(item.getAttribute("data-speed")) || 1;
                    
                    // Center of the element relative to the viewport
                    const elementCenter = rect.top + rect.height / 2;
                    
                    // Distance from the center of the viewport
                    // value is 0 when item is exactly in the middle of the screen
                    const distance = elementCenter - viewportCenter;

                    // Parallax movement: 
                    // As we scroll DOWN, rect.top decreases, distance decreases, moveY decreases.
                    // This moves the item UP relative to its original spot.
                    const moveY = distance * speed * 0.1;

                    // Apply transform
                    item.style.transform = `translate3d(0, ${moveY.toFixed(2)}px, 0)`;
                    
                    // Ensure performance optimizations
                    if (item.style.willChange !== 'transform') {
                        item.style.willChange = 'transform';
                    }
                }
            });
        }

        requestAnimationFrame(animateParallax);
    }

    // Initialize the animation loop
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', animateParallax);
    } else {
        animateParallax();
    }

    // Support for Shopify Theme Editor dynamic loads
    document.addEventListener('shopify:section:load', function() {
        // Items are automatically picked up in the next loop iteration
        animateParallax();
    });

})();
